/* yungi · applique l'état de stock à la fiche produit.
   Lit les données posées sur <body> par layout/theme.liquid.
   Rupture (27/10, demande HAYSOUL : « pas de précommande, ils s'inscrivent pour être prévenus ») :
   le formulaire d'achat est masqué et remplacé par « Me prévenir du retour »
   (e-mail → liste Klaviyo VUJ5f5 « Retour en stock » + client Shopify tagué retour-stock).
   Précommande : inchangée. Le libellé du bouton est verrouillé : le script des offres le réécrit à chaque clic.
   Lancement (29/10, produit pas encore sorti, body data-yg-launch="true") : « Me prévenir de la sortie »,
   liste Klaviyo YyvTQ9 + client Shopify tagué lancement-<handle>, mémoire du formulaire propre au produit. */
(function(){
  if (window.__ygStock) return; window.__ygStock = true;

  var NOTIFY_LIST = 'VUJ5f5';
  var LAUNCH_LIST = 'YyvTQ9';
  var LAUNCH = false, HANDLE = '';

  function popCfg(){
    var p = document.getElementById('ygp');
    var d = (p && p.dataset) || {};
    return { key: d.key || 'XXULRw', proxy: (d.proxy || '').trim() };
  }

  /* même envoi que le pop-up : Klaviyo en direct, proxy de secours si bloqué (VPN, anti-pub) */
  function toKlaviyo(email){
    var c = popCfg();
    var src = LAUNCH ? ('Lancement · Me prévenir de la sortie · ' + HANDLE) : 'Rupture · Me prévenir du retour';
    var body = { data: { type: 'subscription', attributes: { custom_source: src, profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: LAUNCH ? LAUNCH_LIST : NOTIFY_LIST } } } } };
    function viaProxy(){
      if (!c.proxy) return Promise.resolve(null);
      return fetch(c.proxy, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ path: 'subscriptions', payload: body }) })
        .catch(function(){ return null; });
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(c.key), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
    }).then(function(r){ return (r && r.ok) ? r : viaProxy(); }, viaProxy);
  }

  function toShopify(email){
    try {
      var p = new URLSearchParams();
      p.append('form_type', 'customer');
      p.append('utf8', '✓');
      p.append('contact[email]', email);
      p.append('contact[tags]', LAUNCH ? ('newsletter, lancement-' + HANDLE) : 'newsletter, retour-stock');
      return fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: p.toString() })
        .catch(function(){ return null; });
    } catch(e){ return Promise.resolve(null); }
  }

  function memKey(){ return LAUNCH ? ('yg_notify_launch_' + HANDLE) : 'yg_notify_2710'; }

  function notifyBlock(){
    var w = document.createElement('div');
    w.className = 'yg-nt';
    w.id = 'yg-notify';
    w.innerHTML =
      (LAUNCH
        ? '<div class="yg-nt-pill">BIENTÔT DISPONIBLE</div>' +
          '<div class="yg-nt-t">La première production est en cours.</div>' +
          '<div class="yg-nt-s">Laisse ton e-mail : on te prévient en premier dès que c\'est disponible.</div>'
        : '<div class="yg-nt-pill">RUPTURE DE STOCK</div>' +
          '<div class="yg-nt-t">Tout est parti. Le prochain arrivage est en route.</div>' +
          '<div class="yg-nt-s">Laisse ton e-mail : on te prévient en premier dès que c\'est de retour.</div>') +
      '<form class="yg-nt-f" novalidate>' +
        '<input type="email" name="email" inputmode="email" autocomplete="email" placeholder="Ton adresse e-mail" aria-label="Ton adresse e-mail" required>' +
        '<button type="submit">' + (LAUNCH ? 'ME PRÉVENIR DE LA SORTIE' : 'ME PRÉVENIR DU RETOUR') + '</button>' +
      '</form>' +
      '<div class="yg-nt-err" hidden>Vérifie ton adresse e-mail.</div>' +
      '<div class="yg-nt-ok" hidden><b>C\'est noté ✅</b> On t\'écrit dès que c\'est ' + (LAUNCH ? 'disponible' : 'de retour') + '.</div>' +
      '<div class="yg-nt-small">Tu recevras aussi nos offres et nouveautés. Désinscription en un clic.</div>';

    var f = w.querySelector('form');
    var ok = w.querySelector('.yg-nt-ok');
    var err = w.querySelector('.yg-nt-err');
    var small = w.querySelector('.yg-nt-small');
    function showDone(){ f.hidden = true; err.hidden = true; small.hidden = true; ok.hidden = false; }

    f.addEventListener('submit', function(e){
      e.preventDefault();
      var inp = f.querySelector('input');
      var em = (inp.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { err.hidden = false; inp.focus(); return; }
      err.hidden = true;
      var btn = f.querySelector('button');
      btn.disabled = true; btn.textContent = 'UN INSTANT…';
      var finish = function(){ showDone(); try { localStorage.setItem(memKey(), '1'); } catch(x){} };
      Promise.all([toKlaviyo(em), toShopify(em)]).then(finish, finish);
    });

    try { if (localStorage.getItem(memKey())) showDone(); } catch(x){}
    return w;
  }

  function goToNotify(){
    var n = document.getElementById('yg-notify');
    if (!n) return;
    var y = Math.max(0, n.getBoundingClientRect().top + window.pageYOffset - 90);
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch(e){ window.scrollTo(0, y); }
    /* filet : si le défilement animé ne part pas (onglet en arrière-plan), on pose la position */
    setTimeout(function(){ if (Math.abs(window.pageYOffset - y) > 40) window.scrollTo(0, y); }, 700);
    var inp = n.querySelector('input');
    if (inp && !n.querySelector('form').hidden) setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(e){ inp.focus(); } }, 450);
  }

  function boot(){
    var b = document.body;
    if (!b || b.getAttribute('data-yg-instock') !== 'false') return;
    var pre  = b.getAttribute('data-yg-preorder') === 'true';
    LAUNCH = b.getAttribute('data-yg-launch') === 'true';
    HANDLE = b.getAttribute('data-yg-handle') || '';
    if (LAUNCH) pre = false;
    var date = b.getAttribute('data-yg-preorder-date') || '';
    b.classList.add(pre ? 'yg-pre' : 'yg-out');

    var yp = document.querySelector('.yp');
    var atc = yp && yp.querySelector('.atc');
    var offers = yp && yp.querySelector('.offers');

    if (pre) {
      if (atc) {
        var lock = function(){
          var t = atc.textContent || '';
          if (t.indexOf('PRÉCOMMANDER') !== -1) return;
          atc.textContent = t.replace(/AJOUTER AU PANIER/i, 'PRÉCOMMANDER');
        };
        lock();
        try { new MutationObserver(lock).observe(atc, {childList:true, characterData:true, subtree:true}); } catch(e){}
        setTimeout(lock, 400);
        setTimeout(lock, 1200);
      }
      var host = offers || atc;
      if (host && !document.querySelector('.yg-note')) {
        var n = document.createElement('div');
        n.className = 'yg-note pre';
        n.innerHTML = '<span class="ic">!</span><span><b>Précommande.</b> Le stock arrive : ta commande est expédiée <b>à partir du ' + date + '</b>. Tu es servie en priorité, par ordre de commande.</span>';
        host.parentNode.insertBefore(n, host);
      }
    } else {
      /* le formulaire d'achat (offres + bouton) est masqué par yungi-stock.css ; on met l'inscription à sa place */
      if (atc) { atc.setAttribute('disabled', 'disabled'); atc.setAttribute('aria-disabled', 'true'); }
      var form = (atc && atc.closest) ? atc.closest('form') : null;
      var anchor = form || offers || atc;
      if (anchor && anchor.parentNode && !document.getElementById('yg-notify')) {
        anchor.parentNode.insertBefore(notifyBlock(), anchor);
      }
    }

    var dl = document.querySelector('.yp .deliv');
    if (dl) {
      dl.innerHTML = pre
        ? '<span class="dot"></span>Expédition à partir du ' + date
        : (LAUNCH ? '<span class="dot"></span>Première production en cours' : '<span class="dot"></span>Réassort en route');
    }

    var sticky = document.querySelector('.ygsticky-cta');
    if (sticky) {
      if (pre) { sticky.textContent = 'Précommander'; }
      else {
        /* copie sans les écouteurs d'origine (qui défilaient vers les offres, masquées) */
        var s2 = sticky.cloneNode(false);
        s2.textContent = LAUNCH ? 'Me prévenir de la sortie' : 'Me prévenir du retour';
        sticky.parentNode.replaceChild(s2, sticky);
        s2.addEventListener('click', function(e){ e.preventDefault(); goToNotify(); });
      }
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
